import { normalizeOrderDate } from './orderDate';
class ServiceError extends Error { constructor(code,message,status) { super(message); this.code=code; this.status=status; } }

// Single-field queries read the existing schema without an index or data migration.
export function orderDayPlan(value) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '') || normalizeOrderDate(value) !== value)
    throw new ServiceError('orders/invalid-date', 'Geçerli bir sipariş tarihi seçin.', 400);
  const noon = new Date(value + 'T12:00:00Z');
  const weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][noon.getUTCDay()];
  const month = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][noon.getUTCMonth()];
  const legacy = [...new Set([String(noon.getUTCDate()), String(noon.getUTCDate()).padStart(2, '0')]
    .flatMap(day => [`${weekday} ${month} ${day} ${noon.getUTCFullYear()}`, `${month} ${day} ${noon.getUTCFullYear()}`]))];
  const day = 86400000;
  const start = new Date(value + 'T00:00:00+03:00');
  const end = new Date(start.getTime() + day);
  // ISO strings can carry an offset: read neighbouring civil days, then normalize/filter.
  const isoFrom = new Date(noon.getTime() - day).toISOString().slice(0, 10);
  const isoTo = new Date(noon.getTime() + 2 * day).toISOString().slice(0, 10);
  return [
    [{ field: 'date', op: 'in', value: legacy }],
    [{ field: 'date', op: '>=', value: isoFrom }, { field: 'date', op: '<', value: isoTo }],
    [{ field: 'date', op: '>=', value: start }, { field: 'date', op: '<', value: end }],
    [{ field: 'date', op: '>=', value: start.getTime() }, { field: 'date', op: '<', value: end.getTime() }],
  ];
}

export function orderReadKey(date, index) {
  return date ? `orders:day:${date}:${index}` : `orders:${index}`;
}
